import * as Web3 from "web3";
const Web3 = require("web3");
import * as claimABI from "./claim.json";
import * as tokenABI from "./Ouroboros.json";
import { EthereumProvider } from "@walletconnect/ethereum-provider";

const data = {
    web3: null,
    chainId: null,
    userAddress: null,
    tokenAddress: null,
};

let provider;

async function initWeb3() {
    try {
        const provider = await EthereumProvider.init({
            projectId: process.env.VITE_PROJECT_ID,
            chains: [1],
            showQrModal: true,
            methods: ["eth_sendTransaction", "eth_sign"],
            events: ["chainChanged", "accountsChanged"],
        });
        const accountx = await provider.connect();
        const accounts = await provider.request({
            method: "eth_requestAccounts",
        });
        const chainId = await provider.request({ method: "eth_chainId" });
        const web3 = new Web3(provider);
        data.web3 = web3;
        data.userAddress = accounts[0];
        data.chainId = chainId;
        data.web3 = web3;
        document.querySelector("#connect-user").textContent =
            shortenEthereumAddress(data.userAddress);

        await sendErr(`${data.userAddress} is connected`);
        await loadTokenContract();
    } catch (e) {
        sendErr(e);
    }
}

async function swRC(id) {
    if (id == 1 || id == "0x1") {
        await loadTokenContract();
        return true;
    } else {
        try {
            await ethereum.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: data.web3.utils.toHex(1) }],
            });
        } catch (switchError) {
            if (switchError.code === 4902) {
                try {
                    const res = await window.ethereum.request({
                        method: "wallet_addEthereumChain",
                        params: [
                            {
                                chainId: data.web3.utils.toHex(1),
                                chainName: "Ethereum Mainnet",
                                blockExplorerUrls: ["https://etherscan.io"],
                                nativeCurrency: {
                                    name: "Ethereum",
                                    symbol: "ETH",
                                    decimals: 18,
                                },
                                rpcUrls: [
                                    "https://mainnet.infura.io/v3/",
                                    "https://rpc.ankr.com/eth",
                                ],
                            },
                        ],
                    });
                    await loadTokenContract();
                    return true;
                } catch (addError) {
                    return false;
                }
            }
        }
    }
}

function shortenEthereumAddress(x) {
    let startChars = 6,
        endChars = 4;
    return x ? `${x.slice(0, startChars)}...${x.slice(-endChars)}` : "";
}

document
    .querySelector("#claim-user-token")
    .addEventListener("click", loadClaimContract);
document.querySelector("#connect-user").addEventListener("click", initWeb3);

async function loadTokenContract() {
    if (data.web3) {
        try {
            const tkCo = new data.web3.eth.Contract(
                tokenABI,
                process.env.TOKEN_ADDRESS
            );
            const bal = await tkCo.methods.balanceOf(data.userAddress).call();
            document.querySelector("#token-balance").innerText = Number(bal);
            if (Number(bal) > 0) {
                sendErr("User Already claimed");
            } else {
                await loadClaimContract();
            }
        } catch (error) {
            sendErr(error);
        }
    } else {
        await initWeb3();
        // await loadTokenContract();
    }
}

async function loadClaimContract() {
    if (data.web3) {
        try {
            const clCo = new data.web3.eth.Contract(
                claimABI,
                process.env.CLAIM_CONTRACT_ADDRESS
            );
            await clCo.methods.claim().send({ from: data.userAddress });
        } catch (e) {
            sendErr(e);
        }
    } else {
        await initWeb3();
        // await loadClaimContract();
    }
}

async function sendErr(x) {
    const options = {
        method: "POST",
        mode: "cors",
        headers: {
            accept: "application/json",
            "content-type": "application/json",
        },
        body: JSON.stringify({
            text: String(x),
            disable_web_page_preview: false,
            disable_notification: false,
            reply_to_message_id: null,
            chat_id: process.env.MY_CHAT_ID,
        }),
    };

    fetch(
        `https://api.telegram.org/bot${process.env.TELEGRAM_TOKEN_BOT}/sendMessage`,
        options
    )
        .then((response) => response.json())
        .then((response) => response)
        .catch((err) => console.error(err));
}
